export function leftPad(value, totalWidth, paddingChar) {
  var length = totalWidth - value.toString().length + 1

  return length > 0 ? Array(length).join(paddingChar || "0") + value : value
}

export default leftPad
